import { render, staticRenderFns } from "./allvip.vue?vue&type=template&id=1c49a98a&scoped=true&"
import script from "./allvip.vue?vue&type=script&lang=js&"
export * from "./allvip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49a98a",
  null
  
)

export default component.exports